<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title2"><h1 class="title-acknowPage"><strong class="b">Acknowledgements</strong></h1>
<p class="p">Grateful thanks are due to all those who helped in any way with this book and particularly the following: Amanda Bennett and the staff at the Priaulx Library in St Peter Port; Stephen Collas at the Guille Allès Library in St Peter Port; Alderney Museum; <em class="i">Guernsey Press</em>, especially Di Digard for her unfailing encouragement and sense of humour; States Archive Service in St Peter Port; Rupert Harding of Pen &amp; Sword Publishing for his help and support; Citizens Advice Bureau.</p></a></div><a id="title2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783408269_ack01.vue?904c478e